import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import GearMark from "@/components/GearMark";
import { APPS, BOOKING_URL, CONTACT_EMAIL, NAV_LINKS } from "@/config";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative overflow-hidden bg-[#161311] text-white/70">
      <GearMark
        size={520}
        className="pointer-events-none absolute -bottom-44 -left-40 animate-spin-slower opacity-[0.05]"
      />
      <div className="container-t relative grid gap-12 py-16 lg:grid-cols-[1.4fr_0.7fr_1.1fr_0.9fr] lg:py-20">
        <div>
          <div className="flex items-center gap-2.5">
            <GearMark size={32} />
            <span className="font-display text-2xl font-extrabold tracking-[-0.02em] text-white">
              Transactr
            </span>
          </div>
          <p className="mt-4 max-w-sm font-mono text-[11px] uppercase leading-relaxed tracking-[0.18em] text-bluerule/90">
            Autonomous workflows for upselling in the AWS Marketplace
          </p>
          <a
            data-testid="footer-email-link"
            href={`mailto:${CONTACT_EMAIL}`}
            className="mt-6 inline-block text-sm text-white/70 underline-offset-4 transition-colors hover:text-white hover:underline"
          >
            {CONTACT_EMAIL}
          </a>
        </div>

        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-white/40">Navigate</p>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-${l.testid}`}
                  className="text-sm transition-colors duration-300 hover:text-vermillion"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-white/40">Log in</p>
          <ul className="mt-5 space-y-3">
            {APPS.map((a) => (
              <li key={a.id}>
                <a
                  data-testid={`footer-login-${a.id}-link`}
                  href={a.loginUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center gap-1.5 text-sm transition-colors duration-300 hover:text-vermillion"
                >
                  {a.shortName}
                  <ArrowUpRight
                    size={14}
                    className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                  />
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-white/40">Start</p>
          <ul className="mt-5 space-y-3">
            <li>
              <a
                data-testid="footer-book-consultation-link"
                href={BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-1.5 text-sm transition-colors duration-300 hover:text-vermillion"
              >
                Book a consultation
                <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </a>
            </li>
            <li>
              <a
                data-testid="footer-get-a-demo-link"
                href={BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-1.5 text-sm transition-colors duration-300 hover:text-vermillion"
              >
                Get a demo
                <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-t flex flex-col gap-2 py-6 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between">
          <span data-testid="footer-copyright">© {year} Transactr. All rights reserved.</span>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em]">
            Built for the AWS Marketplace
          </span>
        </div>
      </div>
    </footer>
  );
}
